export* from "./create-new-customer-list/create-new-customer-list.component";
export *from "./customer-list-view/customer-list-view.component";